import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PublicLayout from '../components/PublicLayout';
import './CommonPages.css';

const Help = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const tr = i18n.language?.startsWith('tr');
  const [query, setQuery] = useState('');

  const categories = useMemo(
    () =>
      tr
        ? [
            {
              title: 'Genel',
              items: [
                { q: 'ArcVPN nedir?', a: 'Şirketlerin uzaktan ve çok lokasyonlu erişimini yönetmesi için kurumsal bir VPN platformudur.' },
                { q: 'Deneme var mı?', a: 'Evet. Kısa bir deneme ile temel özellikleri kendi ekibinizde deneyebilirsiniz.' },
                { q: 'Kaç cihaz bağlanır?', a: 'Cihaz ve kullanıcı limitleri seçtiğiniz plana göre değişir.' },
              ],
            },
            {
              title: 'Teknik',
              items: [
                { q: 'Hangi platformlar desteklenir?', a: 'Windows, macOS, Linux, iOS ve Android.' },
                { q: 'İlk bağlantı nasıl yapılır?', a: 'Hesap oluşturun, istemciyi kurun, giriş yapın ve onaylı bir düğüme bağlanın.' },
                { q: 'Kill switch ne işe yarar?', a: 'Tünel düşünce cihazın korumasız kalmaması için erişimi keser.' },
              ],
            },
            {
              title: 'Hesap & fatura',
              items: [
                { q: 'Şirketime nasıl kullanıcı eklerim?', a: 'Şirket panelinden davet kodu veya e-posta daveti kullanın.' },
                { q: 'Planı nasıl yükseltirim?', a: 'Pricing sayfasından planları inceleyin veya satış ile konuşun.' },
                { q: '2FA zorunlu mu?', a: 'Hesap güvenliği için önerilir; politika şirket ayarlarına göre yönetilebilir.' },
              ],
            },
          ]
        : [
            {
              title: 'General',
              items: [
                { q: 'What is ArcVPN?', a: 'A corporate VPN platform for managing remote and multi-site access.' },
                { q: 'Is there a trial?', a: 'Yes. You can try the core features with your own team for a short period.' },
                { q: 'How many devices can connect?', a: 'Device and user limits depend on the plan you choose.' },
              ],
            },
            {
              title: 'Technical',
              items: [
                { q: 'Which platforms are supported?', a: 'Windows, macOS, Linux, iOS, and Android.' },
                { q: 'How do I connect the first time?', a: 'Create an account, install a client, sign in, and connect to an approved node.' },
                { q: 'What does kill switch do?', a: 'It cuts access if the tunnel drops so the device is not left exposed.' },
              ],
            },
            {
              title: 'Account & billing',
              items: [
                { q: 'How do I add users to my company?', a: 'Use invite codes or email invites from the company console.' },
                { q: 'How do I upgrade?', a: 'Review plans on Pricing or talk to sales for larger teams.' },
                { q: 'Is 2FA required?', a: 'Recommended for account safety; policy can be guided by company settings.' },
              ],
            },
          ],
    [tr]
  );

  const filtered = categories
    .map((category) => ({
      ...category,
      items: category.items.filter((item) => {
        const hay = `${item.q} ${item.a}`.toLowerCase();
        return hay.includes(query.trim().toLowerCase());
      }),
    }))
    .filter((category) => category.items.length > 0);

  return (
    <PublicLayout
      title={tr ? 'Yardım Merkezi' : 'Help Center'}
      subtitle={tr ? 'Hızlı yanıtlar ve doğru yönlendirme.' : 'Quick answers and clear next steps.'}
    >
      <div className="common-page">
        <div className="help-search-modern">
          <input
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder={tr ? 'Konu ara…' : 'Search topics…'}
          />
        </div>

        {(filtered.length ? filtered : categories).map((category) => (
          <section className="arc-section" key={category.title} style={{ paddingTop: '1.5rem' }}>
            <div className="arc-section-head"><h2>{category.title}</h2></div>
            <div className="faq-modern">
              {category.items.map((item) => (
                <details key={item.q} className="arc-panel faq-modern-item">
                  <summary>{item.q}</summary>
                  <p>{item.a}</p>
                </details>
              ))}
            </div>
          </section>
        ))}

        <section className="arc-cta-band">
          <h2>{tr ? 'Hâlâ takıldınız mı?' : 'Still stuck?'}</h2>
          <p>{tr ? 'Destek ekibine yazın veya dokümantasyona geçin.' : 'Write to support or jump into the docs.'}</p>
          <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
            <button type="button" className="arc-btn arc-btn-solid" onClick={() => navigate('/contact')}>
              {tr ? 'Destek' : 'Support'}
            </button>
            <button type="button" className="arc-btn arc-btn-ghost" onClick={() => navigate('/docs')}>
              {tr ? 'Docs' : 'Docs'}
            </button>
          </div>
        </section>
      </div>
    </PublicLayout>
  );
};

export default Help;
